import { AutogenModelEdiBillingList, AutogenRowEdiBillingList } from "./autogen/AutogenModelEdiBillingList";

export class ModelEdiBillingList extends AutogenModelEdiBillingList<RowEdiBillingList> {
	constructor() {
		super(RowEdiBillingList);
	}
}

export class RowEdiBillingList extends AutogenRowEdiBillingList {
}